/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function trsAddToCart() {
    return {
      error: '',
      buttonText: '',
      showError: false,
      color: null,
      loading: false,
      selectedPrice: null,
      selectedPennies: null,
      selectedVariantId: null,
      checkColorBeforeAdd(e) {
        if(this.color) {
          return this.addToCart();
        }
        window.location.href = this.$refs.link;
      },

      deselect($el) {
        $el.checked = false;
        this.selectedPrice = null;
        this.color = null;
        this.selectedVariantId = null;
      },

      addToCart() {

        this.loading = true;

        document.dispatchEvent(new CustomEvent("theme:loading:start"));

        let formData = Form.serialize(this.$refs.form);

        // Alpine with x-data on form + input with name="id" throws an error, so working around this
        formData.id = formData.variant_id;

        fetch(`${window.routes.cartAddUrl}.js`, {
          body: JSON.stringify(formData),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then((response) => {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          this.loading = false;
          if (response.ok) {

            this.buttonText = 'Item added'

            setTimeout(() => this.buttonText = '', 2000);

            document.documentElement.dispatchEvent(new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 1
              }
            }));
            document.dispatchEvent(new CustomEvent("modal:close"));
          } else {
            response.json().then((content) => {
              this.showMessage(content["description"], "error");
            });
          }
        });
      },

      wholesalePrice(factor) {
        return window.theme.currency + (Math.ceil((this.selectedPennies * factor) / 100) / 100).toFixed(2);
      },

      showMessage(message, type) {
        this.error = message;
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    }
  }

  function trsSlider() {
    return {
      init() {
        this.$nextTick(() => {
          this.slider = this.$refs.slider;
          this.scrollLeftBtn = this.$refs.left; 
          this.scrollRightBtn = this.$refs.right;

          this.updateButtonVisibility();

          // Set up event listeners
          this.slider.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => this.updateButtonVisibility(), 50);
          });

          window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => this.updateButtonVisibility(), 150);
          });
        });
      },

      scrollLeft() {
        const amount = this.getScrollAmount();
        this.slider.scrollBy({
          left: -amount,
          behavior: 'smooth'
        });
      },

      scrollRight() {
        const amount = this.getScrollAmount();
        this.slider.scrollBy({
          left: amount,
          behavior: 'smooth'
        });
      },

      getScrollAmount() {
        return this.slider.clientWidth * 0.8;
      },

      updateButtonVisibility() {
        const tolerance = 1;
        const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;

        if (this.slider.scrollWidth <= this.slider.clientWidth) {
          this.scrollLeftBtn.classList.add('tw-opacity-0');
          this.scrollRightBtn.classList.add('tw-opacity-0');
          return;
        }

        if (this.slider.scrollLeft <= tolerance) {
          this.scrollLeftBtn.classList.add('tw-opacity-0');
        } else {
          this.scrollLeftBtn.classList.remove('tw-opacity-0');
        }

        if (this.slider.scrollLeft >= maxScrollLeft - tolerance) {
          this.scrollRightBtn.classList.add('tw-opacity-0');
        } else {
          this.scrollRightBtn.classList.remove('tw-opacity-0');
        }
      }
    }
  }

document.addEventListener('alpine:init', () => {
  Alpine.data('trsModal', () => ({
    open: false, 
    content: '', 
    title: '', 
    img: '', 
    actuallyOpen: false,

    init() {
      this.$watch('open', (v) => { 
        if(v) {
          setTimeout(() => this.actuallyOpen = true, 300);
        } else {
          setTimeout(() => {
            this.img = '';
            this.content = '';
            this.title = '';
          }, 300);            
        }
      });
    },

    populate($e) {
      this.open = true;      
      let data = JSON.parse($e.detail.data);
      this.title = data.title;
      this.content = data.content;
      this.img = data.img;
    }
  }))
})

// PDP: unselect variant and disable add button with exception for querystring
let checkedProductOption = document.querySelector('product-form input[type=radio]:checked');
let addBtn = document.querySelector('button.product-form__add-button.button.button--primary');
if(checkedProductOption && document.location.search.indexOf('variant=') === -1) {
  checkedProductOption.checked = false;
  addBtn.classList.add('tw-opacity-50', 'tw-pointer-events-none');
  addBtn.innerHTML = 'Select color';
}


// document.addEventListener('variant:changed', function(event) {
//   console.log("HELLO!");
// });